import { render } from "./ProjectsComp.vue?vue&type=template&id=764f4968"
import script from "./ProjectsComp.vue?vue&type=script&lang=js"
export * from "./ProjectsComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__